export const sortArrayBasedonArrayOrder = (arrayToSort, sortedArrayIds, objectPropsToFilter) =>
  sortedArrayIds?.map((x) => arrayToSort.filter((y) => objectPropsToFilter(y) === x))?.flat();
